import { createContext } from 'react';
import type { Locale, TranslateFn } from '@/i18n/types';

export type LocaleContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: TranslateFn;
};

export const LocaleContext = createContext<LocaleContextValue | null>(null);
